module.exports = __webpack_public_path__ + "img/icon-basic-active.dbc12349.svg";